import { CarouselAlignment, CarouselDirection, useCarousel, } from '@hooks/useCarousel';
import noop from 'lodash/noop';
import * as React from 'react';
const CarouselContext = React.createContext({
    activeIndex: 0,
    alignment: CarouselAlignment.Left,
    direction: CarouselDirection.Horizontal,
    goToIndex: noop,
    goToNext: noop,
    goToPrev: noop,
    maxIndex: 0,
    offset: 0,
    offsets: [],
    recalculate: noop,
    refContainer: null,
    refTrack: null,
});
export const useCarouselContext = () => React.useContext(CarouselContext);
const CarouselProvider = ({ children, resetParam, goTo, ...otherProps }) => {
    const carousel = useCarousel(otherProps);
    React.useEffect(() => {
        carousel.goToIndex(0);
        carousel.recalculate();
    }, [resetParam]);
    React.useEffect(() => {
        if (goTo === undefined) {
            return;
        }
        carousel.goToIndex(goTo);
    }, [goTo]);
    return React.createElement(CarouselContext.Provider, { value: carousel }, children);
};
export default CarouselProvider;
